module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/animation-others.json
// module id = 352
// module chunks = 18553269246700